import React, { Component } from 'react';
import WebSection from './WebSections/WebSection';


export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = { property: '', loading: true };
        this.container = React.createRef();
    }

    scrollToHash(hashName) {
        window.location.hash = "#";
        window.location.hash = "#" + hashName;
    }
    

    componentDidMount() {
        if (this.container.current !== null && this.container.current !== undefined)
        {
            let height = this.container.current.getBoundingClientRect().height;;
            console.log(height);
            // for getting computed styles
            const computed = window.getComputedStyle(this.container.current);// border-radius can be replaced with any other style attributes;
                console.log(computed);
        }
        //console.log('property: ' + this.mainDescriptionContainerRef?.clientHeight);

        //const styles = window.getComputedStyle(this.mainDescriptionContainerRef);
            
        //console.log(styles.color); // rgb(0, 0, 0)
        //console.log(styles.width); // 976px
        //console.log(styles.height); // 976px
        //console.log('property: ' + this.props.property);
        //console.log('propertyDescription: ' + this.props.property.propertyDescription);
        //console.log('propertyDescription.id: ' + this.props.property.propertyDescription.id);
    }

    componentDidUpdate() {
        if (this.container.current !== null && this.container.current !== undefined) {
            let height = this.container.current.getBoundingClientRect().height;;
            console.log(height);
            // for getting computed styles
            const computed = window.getComputedStyle(this.container.current);// border-radius can be replaced with any other style attributes;
            console.log(computed);
        }
        //console.log('property: ' + this.props.property);
        //console.log('propertyDescription: ' + this.props.property.propertyDescription);
        //console.log('propertyDescription.id: ' + this.props.property.propertyDescription.id);
    }

    render() {
        return (
                     
            <>
                
                
               

                {this.props.property && 
                    <>
                    <div  id="main-home" className='main-home'>
                        <div className='main-title-container'>
                            <div className='main-title'>
                                {this.props.property.name}
                            </div>
                            <div className='main-subtitle'>
                                <p>{this.props.property.propertyDescription.subtitle}</p>
                            </div>
                        </div>
                   

                        <div className='main-image-description-container'>
                            <div className='main-image-container'>
                                    <img alt={this.props.property.name} src={this.props.property.mainImageUrl} />
                            </div>
                            <div ref={this.container} className='main-description-container'>
                                <div className='main-description-title'>
                                    <p>{this.props.property.propertyDescription.summaryTitle}</p>
                                </div>
                                <div className='main-description-text'>
                                    <p>{this.props.property.propertyDescription.summary}</p>
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>
                    </>
                }
                {this.props.property &&

                    <div className="row" style={{}}>

                        {this.props.property.webSections.map((webSection) =>
                            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                                <button className="btn" onClick={() => this.scrollToHash(webSection.title)}>
                                    <img src={webSection.image.thumbNail} className="rounded" />
                                    {webSection.title}
                                </button>
                            </div>
                        )
                        }

                    </div>
                }

                {this.props.property &&

                    <div style={{}}>

                    {this.props.property.webSections.map((webSection) =>
                        <WebSection
                            webSection={webSection}
                        />
                                
                        )
                        }

                    </div>
                }

                
            </>
        )
    };


}